import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

import { ISucceededSlipRewardTokenInfo } from '../../models/result-succeeded-slip.model';
import { IRewardTokenBadge } from '../../models/reward-token-badge.model';

@Component({
    selector: 'bs-reward-used',
    templateUrl: './result-reward-used.component.html',
    styleUrls: ['./result-reward-used.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultRewardUsedComponent {
    @Input() rewardTokenInfo: ISucceededSlipRewardTokenInfo;
    @Input() badge: IRewardTokenBadge;

    readonly EntainUi = { showInEpcot: false, module: EpcotModule.Betslip };
    readonly EpcotUi = { showInEpcot: true, module: EpcotModule.Betslip };
    readonly rewardUsedTitle = this.sitecore.crmTokens.confirmation.RewardUsed;
    readonly promotionUsedTitle = this.sitecore.crmTokens.confirmation.PromotionUsed;

    constructor(private sitecore: Sitecore) {}
}
